import CalendarMonth from "@mui/icons-material/CalendarMonth";
import Checklist from "@mui/icons-material/Checklist";
import DataObject from "@mui/icons-material/DataObject";
import Euro from "@mui/icons-material/Euro";
import Flaky from "@mui/icons-material/Flaky";
import Home from "@mui/icons-material/Home";
import Numbers from "@mui/icons-material/Numbers";
import Percent from "@mui/icons-material/Percent";
import Person from "@mui/icons-material/Person";
import SquareFoot from "@mui/icons-material/SquareFoot";
import TextFields from "@mui/icons-material/TextFields";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { ParsingType } from "../../../interfaces/doc";

function ExtractionIcon({
  parsingType,
  props,
}: {
  parsingType: ParsingType;
  props?: SvgIconProps;
}) {
  switch (parsingType) {
    case ParsingType.Name:
      return <Person {...props} />;
    case ParsingType.Address:
      return <Home {...props} />;
    case ParsingType.String:
      return <TextFields {...props} />;
    case ParsingType.Float:
      return <Percent {...props} />;
    case ParsingType.Int:
      return <Numbers {...props} />;
    case ParsingType.Date:
      return <CalendarMonth {...props} />;
    case ParsingType.Measure:
      return <SquareFoot {...props} />;
    case ParsingType.Currency:
      return <Euro {...props} />;
    case ParsingType.Boolean:
      return <Flaky {...props} />;
    case ParsingType.Custom:
      return <DataObject {...props} />;
    case ParsingType.Enum:
      return <Checklist {...props} />;
    default:
      return <TextFields {...props} />;
  }
}

export default ExtractionIcon;
